// Конфиг таймзон
// Приоритетные таймзоны и русские подписи для селекта настроек
// Полный список берется в timezoneUtils из Intl.supportedValuesOf

export const RUSSIAN_TIMEZONE_LABELS = {
  "Europe/Kaliningrad": "Калининград",
  "Europe/Moscow": "Москва",
  "Europe/Kirov": "Киров",
  "Europe/Volgograd": "Волгоград",
  "Europe/Astrakhan": "Астрахань",
  "Europe/Saratov": "Саратов",
  "Europe/Ulyanovsk": "Ульяновск",
  "Europe/Samara": "Самара",
  "Asia/Yekaterinburg": "Екатеринбург",
  "Asia/Omsk": "Омск",
  "Asia/Novosibirsk": "Новосибирск",
  "Asia/Barnaul": "Барнаул",
  "Asia/Tomsk": "Томск",
  "Asia/Novokuznetsk": "Новокузнецк",
  "Asia/Krasnoyarsk": "Красноярск",
  "Asia/Irkutsk": "Иркутск",
  "Asia/Chita": "Чита",
  "Asia/Yakutsk": "Якутск",
  "Asia/Khandyga": "Хандыга",
  "Asia/Vladivostok": "Владивосток",
  "Asia/Ust-Nera": "Усть-Нера",
  "Asia/Magadan": "Магадан",
  "Asia/Sakhalin": "Сахалин",
  "Asia/Srednekolymsk": "Среднеколымск",
  "Asia/Kamchatka": "Камчатка",
  "Asia/Anadyr": "Анадырь",
};

export const COMMON_TIMEZONE_LABELS = {
  "Europe/London": "Лондон",
  "Europe/Berlin": "Берлин",
  "Europe/Istanbul": "Стамбул",
  "Asia/Almaty": "Алматы",
  "Asia/Tashkent": "Ташкент",
  "Asia/Dubai": "Дубай",
  "Asia/Shanghai": "Шанхай",
  "Asia/Tokyo": "Токио",
  "America/New_York": "Нью-Йорк",
  "America/Los_Angeles": "Лос-Анджелес",
};
